/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateProfileShow } from '../../axios/candidateProfileShow'
import type {
	CandidateProfileShowError,
	CandidateProfileShowPathParams,
	CandidateProfileShowResponse,
} from '../../types/CandidateProfileShow'

export const candidateProfileShowQueryKey = (candidate: CandidateProfileShowPathParams['candidate']) =>
	[{ url: '/candidates/:candidate/profile', params: { candidate } }] as const

export type CandidateProfileShowQueryKey = ReturnType<typeof candidateProfileShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateProfileController.php CandidateProfileController::show */
export function candidateProfileShowQueryOptions(
	candidate: CandidateProfileShowPathParams['candidate'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CandidateProfileShowResponse,
		AxiosError<CandidateProfileShowError>,
		CandidateProfileShowResponse,
		CandidateProfileShowQueryKey
	>({
		queryKey: candidateProfileShowQueryKey(candidate),
		queryFn: ({ signal }) => candidateProfileShow(candidate, { signal, ...config }).then(res => res.data),
		enabled: !!candidate,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateProfileController.php CandidateProfileController::show */
export function useCandidateProfileShow<TSelectData = CandidateProfileShowResponse>(
	candidate: CandidateProfileShowPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CandidateProfileShowResponse,
					AxiosError<CandidateProfileShowError>,
					TSelectData,
					CandidateProfileShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CandidateProfileShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...candidateProfileShowQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateProfileController.php CandidateProfileController::show */
export function useCandidateProfileShowSuspense<TSelectData = CandidateProfileShowResponse>(
	candidate: CandidateProfileShowPathParams['candidate'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CandidateProfileShowResponse,
					AxiosError<CandidateProfileShowError>,
					TSelectData,
					CandidateProfileShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CandidateProfileShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...candidateProfileShowQueryOptions(candidate),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
